<template>
  <div id="app" class="site">
    <header class="site-header">
      <div class="site-header__pattern cn-cloud-pattern" aria-hidden="true" />
      <div class="site-header__inner">
        <div class="logo" @click="goHome">
          <img src="@/assets/logo/logo.png" class="logo-icon" alt="百年票票" />
          <div class="logo-text-wrap">
            <span class="logo-text">百年票票</span>
            <span class="logo-sub">西安文旅票务平台</span>
          </div>
        </div>

        <nav class="site-nav site-nav--desktop">
          <router-link
            v-for="item in navItems"
            :key="item.path"
            :to="item.path"
            class="site-nav__link"
            active-class="site-nav__link--active"
            @click.native="menuOpen = false"
          >
            {{ item.label }}
          </router-link>
        </nav>

        <button
          class="menu-toggle"
          :class="{ 'menu-toggle--open': menuOpen }"
          type="button"
          :aria-label="menuOpen ? '关闭菜单' : '打开菜单'"
          @click="menuOpen = !menuOpen"
        >
          <span class="menu-toggle__bar" />
          <span class="menu-toggle__bar" />
          <span class="menu-toggle__bar" />
        </button>

        <el-button
          class="site-header__cta"
          type="danger"
          size="small"
          round
          @click="goTicket"
        >
          官方购票
        </el-button>
      </div>
    </header>
    <nav class="site-nav site-nav--mobile" :class="{ 'site-nav--open': menuOpen }">
      <router-link
        v-for="item in navItems"
        :key="'m-' + item.path"
        :to="item.path"
        class="site-nav__link"
        active-class="site-nav__link--active"
        @click.native="menuOpen = false"
      >
        {{ item.label }}
      </router-link>
      <el-button
        class="site-nav__cta-mobile"
        type="danger"
        size="small"
        round
        @click="goTicket"
      >
        官方购票
      </el-button>
    </nav>
    <div v-if="menuOpen" class="menu-overlay" @click="menuOpen = false" />
    <main class="site-main">
      <router-view />
    </main>
    <footer class="site-footer">
      <div class="site-footer__inner">
        <div class="site-footer__brand">
          <img src="@/assets/logo/logo.png" class="site-footer__logo" alt="百年票票" />
          <div>
            <strong>百年票票</strong>
            <p>西安本地官方直营 · 王牌演艺特惠 · 精品一日游</p>
          </div>
        </div>
        <div class="site-footer__links">
          <div class="site-footer__col">
            <h4>快速导航</h4>
            <router-link to="/">首页</router-link>
            <router-link to="/performance">演艺介绍</router-link>
            <router-link to="/news">新闻资讯</router-link>
            <router-link to="/service">服务中心</router-link>
          </div>
          <div class="site-footer__col">
            <h4>热门产品</h4>
            <span>长恨歌</span>
            <span>驼铃传奇</span>
            <span>千古情</span>
            <span>丝路欢乐世界</span>
          </div>
          <div class="site-footer__col">
            <h4>联系我们</h4>
            <router-link to="/service#ticket">官方公众号购票</router-link>
            <router-link to="/service#wework">企业微信客服</router-link>
            <router-link to="/service#phone">联系电话</router-link>
            <router-link to="/service#feedback">投诉建议</router-link>
          </div>
        </div>
      </div>
      <div class="site-footer__copy">
        <p>© {{ year }} 百年票票 · 西安文旅票务平台官方网站</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      menuOpen: false,
      navItems: [
        { label: '首页', path: '/' },
        { label: '演艺介绍', path: '/performance' },
        { label: '新闻资讯', path: '/news' },
        { label: '服务中心', path: '/service' }
      ]
    };
  },
  computed: {
    year() {
      return new Date().getFullYear();
    }
  },
  watch: {
    $route() {
      this.menuOpen = false;
    }
  },
  methods: {
    goHome() {
      this.menuOpen = false;
      this.$router.push('/');
    },
    goTicket() {
      this.menuOpen = false;
      this.$router.push('/service#ticket');
    }
  }
};
</script>

<style scoped>
.site {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
  color: #303133;
}
.site-header {
  position: sticky;
  top: 0;
  z-index: 300;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.06);
}
.site-header::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #d4a04a 20%, #c41e3a 50%, #d4a04a 80%, transparent);
  pointer-events: none;
}
.site-header__pattern {
  position: absolute;
  inset: 0;
  opacity: 0.35;
  pointer-events: none;
  z-index: 0;
}
.site-header__inner {
  max-width: 1200px;
  margin: 0 auto;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  gap: 16px;
  position: relative;
  z-index: 1;
}
.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  user-select: none;
  flex-shrink: 0;
  z-index: 201;
}
.logo-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
}
.logo-text-wrap {
  display: flex;
  flex-direction: column;
}
.logo-text {
  font-size: 20px;
  font-weight: 700;
  color: #c41e3a;
  letter-spacing: 3px;
  line-height: 1.2;
}
.logo-sub {
  font-size: 11px;
  color: #909399;
  letter-spacing: 1px;
}
.menu-toggle {
  display: none;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  z-index: 201;
  position: relative;
  flex-shrink: 0;
}
.menu-toggle__bar {
  display: block;
  position: absolute;
  left: 8px;
  width: 24px;
  height: 2px;
  border-radius: 1px;
  background: #606266;
  transition: transform 0.25s ease, opacity 0.2s ease, top 0.25s ease, background 0.2s ease;
}
.menu-toggle__bar:nth-child(1) {
  top: 12px;
}
.menu-toggle__bar:nth-child(2) {
  top: 19px;
}
.menu-toggle__bar:nth-child(3) {
  top: 26px;
}
.menu-toggle:hover .menu-toggle__bar {
  background: #c41e3a;
}
.menu-toggle--open .menu-toggle__bar:nth-child(1) {
  top: 19px;
  transform: rotate(45deg);
}
.menu-toggle--open .menu-toggle__bar:nth-child(2) {
  opacity: 0;
}
.menu-toggle--open .menu-toggle__bar:nth-child(3) {
  top: 19px;
  transform: rotate(-45deg);
}
.site-nav {
  display: flex;
  align-items: center;
  gap: 4px;
}
.site-nav--desktop {
  flex: 1;
  justify-content: center;
  min-width: 0;
}
.site-nav--mobile {
  display: none;
}
.site-nav__link {
  padding: 8px 20px;
  font-size: 15px;
  color: #606266;
  text-decoration: none;
  border-radius: 20px;
  transition: color 0.2s, background 0.2s;
}
.site-nav__link:hover {
  color: #c41e3a;
  background: #fef0f2;
}
.site-nav__link--active {
  color: #c41e3a;
  font-weight: 600;
  background: #fef0f2;
}
.site-nav__cta-mobile {
  display: none;
}
.site-header__cta {
  flex-shrink: 0;
}
.menu-overlay {
  display: none;
  position: fixed;
  inset: 68px 0 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 250;
}
.site-main {
  flex: 1 0 auto;
}
.site-footer {
  flex-shrink: 0;
  position: relative;
  background: #f7f8fa;
  color: #606266;
}
.site-footer::before {
  content: '';
  display: block;
  height: 2px;
  background: linear-gradient(90deg, transparent, #d4a04a 20%, #c41e3a 50%, #d4a04a 80%, transparent);
}
.site-footer__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 24px 28px;
  display: flex;
  gap: 48px;
  flex-wrap: wrap;
}
.site-footer__brand {
  display: flex;
  gap: 14px;
  flex: 1;
  min-width: 240px;
}
.site-footer__logo {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
}
.site-footer__brand strong {
  display: block;
  font-size: 18px;
  color: #c41e3a;
  letter-spacing: 3px;
  margin-bottom: 8px;
}
.site-footer__brand p {
  margin: 0;
  font-size: 13px;
  line-height: 1.7;
  color: #909399;
}
.site-footer__links {
  display: flex;
  gap: 48px;
  flex-wrap: wrap;
}
.site-footer__col {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 120px;
}
.site-footer__col h4 {
  margin: 0 0 10px;
  padding-bottom: 8px;
  font-size: 14px;
  color: #303133;
  font-weight: 600;
  letter-spacing: 1px;
  border-bottom: 1px solid #ebeef5;
}
.site-footer__col a,
.site-footer__col span {
  font-size: 13px;
  color: #606266;
  text-decoration: none;
  line-height: 1.6;
}
.site-footer__col a:hover {
  color: #c41e3a;
}
.site-footer__copy {
  border-top: 1px solid #ebeef5;
  padding: 18px 24px;
  text-align: center;
}
.site-footer__copy p {
  margin: 0;
  font-size: 12px;
  color: #909399;
}
@media (max-width: 768px) {
  .site-header__inner {
    height: 56px;
    padding: 0 16px;
  }
  .logo-sub {
    display: none;
  }
  .logo-text {
    font-size: 18px;
  }
  .menu-toggle {
    display: block;
  }
  .site-header__cta {
    display: none;
  }
  .site-nav--desktop {
    display: none;
  }
  .site-nav--mobile {
    display: flex;
    position: fixed;
    top: 56px;
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: stretch;
    background: #fff;
    padding: 12px 16px 20px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    transform: translateY(calc(-100% - 56px));
    opacity: 0;
    pointer-events: none;
    transition: transform 0.25s ease, opacity 0.25s ease;
    z-index: 280;
  }
  .site-nav--mobile.site-nav--open {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
  }
  .site-nav__link {
    padding: 12px 16px;
    border-radius: 8px;
    text-align: center;
  }
  .site-nav__cta-mobile {
    display: block;
    margin-top: 8px;
    width: 100%;
  }
  .menu-overlay {
    display: block;
    inset: 56px 0 0;
  }
  .site-footer__inner {
    padding: 32px 16px 24px;
    gap: 28px;
  }
  .site-footer__links {
    gap: 24px;
    width: 100%;
  }
  .site-footer__col {
    flex: 1;
    min-width: calc(50% - 12px);
  }
}
</style>
